import { $_app_server } from '@/_helpers'

export const eventService = {
  getEventTags,
  editEventTag,
  removeEventTag,
  getEvents,
  createEvent,
  changeEvent,
  removeEvent,
  getEventById,
  testEventsAPI
}

function getEventTags () {
  return $_app_server.get('eventtags').then(response => response.data)
}

function editEventTag (tag) {
  return $_app_server.put(`eventtags`, tag).then(response => response.data)
}

function removeEventTag (eventTagId) {
  return $_app_server.delete(`/eventtags/${eventTagId}`).then(response => response.data)
}

function getEvents (from, to) {
  return $_app_server.get('event', { params: { from, to }} ).then(response => response.data)
}

function createEvent (event) {
  return $_app_server.post('event', event).then(response => response.data)
}

function changeEvent (event) {
  return $_app_server.put('event', event).then(response => response.data)
}

function removeEvent (eventId) {
  return $_app_server.delete(`/event/${eventId}`).then(response => response.data)
}

function getEventById (eventId) {
  return $_app_server.get(`/event/${eventId}`).then(response => response.data)
}




async function testEventsAPI () {
  console.log("🔺 START TEST")

  console.log("1️⃣ GET EVENTS TAGS")
  let tags = await getEventTags().then(data => data)
  console.log("Tags:", tags)

  console.log("2️⃣ GET EVENTS")
  let events = await getEvents().then(data => data)
  console.log("Events:", events[0])

  console.log("3️⃣ CREATE EVENT")
  let newEvent = await createEvent(testEvent).then(data => data)
  console.log("New event:", newEvent)

  if (newEvent) {
    let eventId = newEvent.id

    console.log("4️⃣ GET EVENT BY ID: " + eventId)
    let eventById = await getEventById(eventId).then(data => data)
    console.log("Event:", eventById)

    console.log("5️⃣ CHANGE NEW EVENT")
    
    eventById.durability = 120
    eventById.eventDate = "2019-04-22 12:00"
    eventById.name = "Renamed event"
    eventById.place = "Moved place"
    eventById.notes = "New testing notes"
    eventById.eventTags = [
      {id: 7, name: "заседания"},
      {name: "test-tag"}
    ]
  
    let changedEvent = await changeEvent(eventById).then(data => data)
    console.log("Change:", changedEvent)

    console.log("6️⃣ REMOVE NEW EVENT")
    let result = await removeEvent(eventId).then(data => data)
    console.log("Remove result:", result)
    
    console.log("7️⃣ CHECK THAT EVENT REMOVED")
    let checkEvent = await getEventById(eventId).then(data => data)
    console.log("Check:", checkEvent)
  }
  else {
    console.log("❌ EVENT IS NULL")
  }

  console.log("🔺 END TEST")
}

let testEvent = {
  durability: 60,
  eventDate: "2019-04-19 10:00",
  eventTags: [
    {id: 8, name: "личное"}
  ],
  name: "Тестовый эвент",
  notes: "Тестируем",
  periodic: null,
  place: "Тестовый зал",
}